
// 说明：SVG路径常量集合，用于简化SVG路径的书写。
// svg路径尽量层级为一级，便于后续维护。
// 为了实现动态导入，但是不修改之前的多层嵌套的svg，所以先写死固定的SVG路径常量集合。
// TIPS：有在assets/svg中 新增的svg图片，需要增加到这个里面，不然会出错
// 可以在根目录下，执行命令-自动写入：npm run svgPath

 export const SVGPATH = {
  "time-left": "about/time-left.svg",
  "add": "add.svg",
  "address": "address.svg",
  "all-function": "all-function.svg",
  "apply_no": "apply_no.svg",
  "apply_phone": "apply_phone.svg",
  "apply_user": "apply_user.svg",
  "arrow-down": "arrow-down.svg",
  "btn-download": "btn-download.svg",
  "buttonDownload": "buttonDownload.svg",
  "check-mark": "check-mark.svg",
  "check": "check.svg",
  "checked-active": "checked-active.svg",
  "checked": "checked.svg",
  "chevron-left": "chevron-left.svg",
  "chevron-right": "chevron-right.svg",
  "chevron-route": "chevron-route.svg",
  "chevronDown": "chevronDown.svg",
  "chevronUp": "chevronUp.svg",
  "circle": "circle.svg",
  "clear": "clear.svg",
  "close-fat": "close-fat.svg",
  "close-pic": "close-pic.svg",
  "close-pic1": "close-pic1.svg",
  "close": "close.svg",
  "cn_logo": "cn_logo.svg",
  "computer": "contact/computer.svg",
  "email": "contact/email.svg",
  "phone": "contact/phone.svg",
  "qq": "contact/qq.svg",
  "tel": "contact/tel.svg",
  "contact-chat": "contact-chat.svg",
  "contact-service": "contact-service.svg",
  "contact-whatapp": "contact-whatapp.svg",
  "contact-sale": "contact-sale.svg",
  "contact-email": "contact-email.svg",
  "contact-phone": "contact-phone.svg",
  "contact_mobile_no": "contact_mobile_no.svg",
  "contact_mobile_noJp": "contact_mobile_noJp.svg",
  "contact_mobile_whatsApp": "contact_mobile_whatsApp.svg",
  "au": "country/au.svg",
  "cn": "country/cn.svg",
  "de": "country/de.svg",
  "ex": "country/ex.svg",
  "fr": "country/fr.svg",
  "gb": "country/gb.svg", // TODO
  "hk": "country/hk.svg",
  "jp": "country/jp.svg",
  "kr": "country/kr.svg", // TODO
  "my": "country/my.svg",
  "eu": "country/eu.svg", // TODO
  "in": "country/in.svg", // TODO
  "ru": "country/ru.svg",
  "sg": "country/sg.svg",
  "th": "country/th.svg",
  "us": "country/us.svg",
  "vn": "country/vn.svg",

  "delete": "delete.svg",
  "document": "document.svg",
  "e-mail": "e-mail.svg",
  "edit": "edit.svg",
  "enterprise_login": "enterprise_login.svg",
  "eye-close": "eye-close.svg",
  "eye-open": "eye-open.svg",
  "faqA": "faqA.svg",
  "faqQ": "faqQ.svg",
  "file-delete": "file-delete.svg",
  "excel-icon": "fileType/excel-icon.svg",
  "pdf-icon": "fileType/pdf-icon.svg",
  "word-icon": "fileType/word-icon.svg",
  "ppt-icon": "fileType/ppt-icon.svg",
  "txt-icon": "fileType/txt-icon.svg",
  "file": "file.svg",
  "formCopy": "form/formCopy.svg",
  "formDelete": "form/formDelete.svg",
  "formEdit": "form/formEdit.svg",
  "header-country": "header-country.svg",
  "header-lang": "header-lang.svg",
  "header-user": "header-user.svg",
  "homeBackground1": "homeBackground1.svg",
  "homeBackground2": "homeBackground2.svg",
  "homemore": "homemore.svg",
  "shipping-method": "icons/shipping-method.svg",
  "home_chaxun": "home_chaxun.svg",
  "home_search": "icons/home_search.svg",
  "home_chevron": "home_chevron.svg",
  "home_clearanceService": "home_clearanceService.svg",
  "home_del": "home_del.svg",
  "home_lijichadan": "home_lijichadan.svg",
  "home_mashangjijian": "home_mashangjijian.svg",
  "home_meun": "home_meun.svg",
  "home_yunfeishixiaochaxun": "home_yunfeishixiaochaxun.svg",
  "iconDown": "iconDown.svg",
  "iconFrom": "iconFrom.svg",
  "iconMail": "iconMail.svg",
  "iconNoData": "iconNoData.svg",
  "iconNotSupport": "iconNotSupport.svg",
  "iconPartialSupport": "iconPartialSupport.svg",
  "iconPath": "iconPath.svg",
  "iconReceive": "iconReceive.svg",
  "iconRight": "iconRight.svg",
  "iconSearch": "iconSearch.svg",
  "iconSupport": "iconSupport.svg",
  "info": "info.svg",
  "info_solid": "info_solid.svg",
  "lijichaxun": "lijichaxun.svg",
  "logo_black": "logo_black.svg",
  "logo_white": "logo_white.svg",
  "mail": "mail.svg",
  "mark_exclamation": "mark_exclamation.svg",
  "mark_question": "mark_question.svg",
  "mark_question_solid": "mark_question_solid.svg",
  "message_error": "message/message_error.svg",
  "message_info": "message/message_info.svg",
  "message_success": "message/message_success.svg",
  "message_warning": "message/message_warning.svg",
  "message_warning_active": "message/message_warning_active.svg",
  "mobile-close": "mobile-close.svg",
  "more": "more.svg",
  "notify": "notify.svg",
  "notify1": "notify1.svg",
  "notify2": "notify2.svg",
  "package-box": "package-box.svg",
  "pdf": "pdf.svg",
  "personalCanada": "personalCanada.svg",
  "personalUs": "personalUs.svg",
  "plus": "plus.svg",
  "queryWaybill": "queryWaybill.svg",
  "question": "question.svg",
  "right-nav-back-top": "right-nav-back-top.svg",
  "search-left": "search-left.svg",
  "search": "search.svg",
  "sendMail": "sendMail.svg",
  "solidArrow": "solidArrow.svg",
  "submitHistoryIcon": "submitHistoryIcon.svg",
  "trash-2": "trash-2.svg",
  "apply-type": "support/apply-type.svg",
  "direction": "support/direction.svg",
  "doc-upload-type": "support/doc-upload-type.svg",
  "freightArrow": "support/freightArrow.svg",
  "freightDelivery": "support/freightDelivery.svg",
  "freightEdit": "support/freightEdit.svg",
  "support_curve": "support/support_curve.svg",
  "support_exchange": "support/support_exchange.svg",
  "support_title_bg": "support/support_title_bg.svg",
  "symbol-add": "symbol-add.svg",
  "take-picture": "take-picture.svg",
  "upload": "upload.svg",
  "collect": "waybill/collect.svg",
  "delivered": "waybill/delivered.svg",
  "delivery": "waybill/delivery.svg",
  "express-direction": "waybill/express-direction.svg",
  "invalid": "waybill/invalid.svg",
  "landing": "waybill/landing.svg",
  "other": "waybill/other.svg",
  "packaged": "waybill/packaged.svg",
  "pickedup": "waybill/pickedup.svg",
  "picking": "waybill/picking.svg",
  "received": "waybill/received.svg",
  "signed": "waybill/signed.svg",
  "take_off": "waybill/take_off.svg",
  "wechat": "wechat.svg",
  "whole-calculate": "whole-calculate.svg",
  "whole-shipping": "whole-shipping.svg",
  "whole-tracking": "whole-tracking.svg",
  "billing-invoicing": "billing-invoicing.svg",
  "shipment-complaints": "shipment-complaints.svg",
  "customs-inquriy": "customs-inquriy.svg"
};


